import React, { useContext, useState } from "react";

import PropTypes from "prop-types";
import { UiToast } from "@ask-christee/ui-response";

import { AddButton } from "../../atoms";
import { AddZipCodesModal } from "../AddZipCodesModal";
import { AccountDataProviderContext } from "../../../contexts";

export const AddZipCodes = ({ disabled }) => {
  const { accountData, updateAccountData, setIsDataFetched } = useContext(
    AccountDataProviderContext,
  );

  const [showModal, setShowModal] = useState(false);

  const onSuccessSubmit = (response) => {
    updateAccountData({
      subscriptionItems: [...accountData.subscriptionItems, ...response.data],
    });
    setIsDataFetched((prevState) => ({
      ...prevState,
      billingHistoryFetched: false,
    }));

    UiToast.success("New zip code(s) successfully added!");
  };

  return (
    <>
      <AddButton
        disabled={disabled}
        onClick={() => setShowModal(true)}
        title="Add Zip Code"
      />
      <AddZipCodesModal
        title="Add Zip Code"
        showModal={showModal}
        onSuccessSubmit={onSuccessSubmit}
        handleCloseModal={() => setShowModal(false)}
      />
    </>
  );
};

AddZipCodes.propType = {
  disabled: PropTypes.bool,
};
